<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/bots">Bots</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message v-if="bot.deleted_at" class="mb-6" @restore="restore"> This bot has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
          <text-input v-model="form.token" :error="form.errors.token" class="pb-8 pr-6 w-full lg:w-1/2" label="Token" />
          <text-input v-model="form.note" :error="form.errors.note" class="pb-8 pr-6 w-full lg:w-1/2" label="Note" />
          <label class="flex items-center select-none" for="active">
            <input id="active" v-model="form.active" class="mr-1" type="checkbox" />
            <span class="text-sm">Active</span>
          </label>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!bot.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Bot</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Bot</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    bot: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.bot.name,
        token: this.bot.token,
        note: this.bot.note,
        active: !! this.bot.active,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/bots/${this.bot.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this bot?')) {
        this.$inertia.delete(`/bots/${this.bot.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this bot?')) {
        this.$inertia.put(`/bots/${this.bot.id}/restore`)
      }
    },
  },
}
</script>
